export default __webpack_public_path__ + "static/media/heart.12ec383c.svg";